import { baseUrl } from '@fs/zion-config'

export default function getSearchResultsPagePath(withBaseUrl) {
  return `${withBaseUrl ? baseUrl : ''}/records/images/search-results`
}

export function toOperatorPagePath(operatorId) {
  return `/home/operator?cameraOperatorId=${operatorId}`
}

export function toOperatorPagePathWithWeekending(operatorId, weekEnding, projectId) {
  return `/home/operator/${weekEnding}?cameraOperatorId=${operatorId}&projectId=${projectId}`
}

export function toSearchResultsWithProjectId(projectId) {
  return `${getSearchResultsPagePath(true)}?projectId=${projectId}`
}
